import { PulseBaseProvider } from '../../base-classes';
import { OutdoorSportsSummaryData, OutdoorSportsDetailData, OutdoorSportsLegendData } from '../actions/outdoorSportsActions';

const _outdoorSportsSummaryCacheKey = 'outdoorSportsSummary';
const _outdoorSportsDetailCacheKey = 'outdoorSportsDetail';
const _outdoorSportsLegendCacheKey = 'outdoorSportsLegend';
const _outdoorSportsSummaryUri='/api/otdr/sports/v1/summary';
const _outdoorSportsDetailUri = '/api/otdr/sports/v1/details';
const _outdoorSportsLegendUri = '/api/otdr/sports/v1/legend';


export class outdoorSportsProvider extends PulseBaseProvider {
    constructor(baseUrl: string, authId: string, secret: string) {
        super(baseUrl, authId, secret, undefined, undefined);
        this.storage.sync[_outdoorSportsSummaryCacheKey] = this.outdoorSportsSummarySyncer.bind(this);   
        this.storage.sync[_outdoorSportsDetailCacheKey] = this.outdoorSportsDetailSyncer.bind(this);    
        this.storage.sync[_outdoorSportsLegendCacheKey] = this.outdoorSportsLegendSyncer.bind(this);
    }

    async outdoorSportsSummarySyncer(params: any): Promise<OutdoorSportsSummaryData> {

        const { id, syncParams, resolve, reject } = params;
 
        const queryParams = {
            ...syncParams.stdParameters,
            locationType: 'latitudelongitude',
            location: `${syncParams.latitude},${syncParams.longitude}`,
            cachedOnly: syncParams.isCached,
            verbose: syncParams.verbose
        };

        return await super.syncData(syncParams.key, id, queryParams, _outdoorSportsSummaryUri, resolve, reject, null, syncParams.pulseApi);
    }

    async getOutdoorSportsSummary(latitude: string, longitude: string, isCached: boolean, stdParameters: string, verbose: boolean): Promise<OutdoorSportsSummaryData> {

        const params = {
            latitude,
            longitude,
            verbose: !!verbose,
            isCached
        };
        const id = JSON.stringify(params);

        const syncParams = {
            latitude,
            longitude,
            verbose: !!verbose,
            isCached,
            stdParameters
        };
 
        return await super.loadFromStorage(_outdoorSportsSummaryCacheKey, id, syncParams);
    }

    async outdoorSportsDetailSyncer(params: any): Promise<OutdoorSportsDetailData> {
        const { id, syncParams, resolve, reject } = params;
        const queryParams = {
            ...syncParams.stdParameters,
            temperatureUnit: syncParams.tempUnit,
            speedUnit: syncParams.speedUnit,
            distanceUnit: syncParams.distanceUnit,
            locationType: 'latitudelongitude',
            location: `${syncParams.latitude},${syncParams.longitude}`,
            isCached: syncParams.isCached,
            verbose: syncParams.verbose,
            useCache: syncParams.useCache
        };

        return await super.syncData(syncParams.key, id, queryParams, _outdoorSportsDetailUri, resolve, reject, undefined, syncParams.pulseApi);
    }

    async getOutdoorSportsDetail(latitude: string, longitude: string, isCached: boolean, tempUnit: string, speedUnit: string, distanceUnit: string, stdParameters: string, verbose: boolean) : Promise<OutdoorSportsDetailData> {
        const params = {
            latitude,
            longitude,
            verbose: !!verbose,
            tempUnit,
            speedUnit,
            distanceUnit,
            isCached
        };
        const id = JSON.stringify(params);

        const syncParams = {
            latitude,
            longitude,
            verbose: !!verbose,
            tempUnit,
            speedUnit,
            distanceUnit,
            isCached,
            stdParameters
        };

        return await super.loadFromStorage(_outdoorSportsDetailCacheKey, id, syncParams);
    }

    async outdoorSportsLegendSyncer(params: any): Promise<OutdoorSportsLegendData> {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            locationType: 'latitudelongitude',
            location: `${syncParams.latitude},${syncParams.longitude}`,
            isCached: syncParams.isCached,
            verbose: syncParams.verbose,
            useCache: syncParams.useCache
        };

        return await super.syncData(syncParams.key, id, queryParams, _outdoorSportsLegendUri, resolve, reject, undefined, syncParams.pulseApi);
    }

    async getOutdoorSportsLegend(latitude: string, longitude: string, isCached: boolean, stdParameters: string, verbose: boolean): Promise<OutdoorSportsLegendData> {

        const params = {
            latitude,
            longitude,
            verbose: !!verbose,
            isCached
        };
        const id = JSON.stringify(params);

        const syncParams = {
            latitude,
            longitude,
            verbose: !!verbose,
            isCached,
            stdParameters
        };
 
        return await super.loadFromStorage(_outdoorSportsLegendCacheKey, id, syncParams);
    }
   
}
